import _ from 'lodash'

// Channels that carry no channel_type in the data; the "Channel Type" filter is hidden when only these are selected.
const NO_TYPE_CHANNELS = ["Linear", "Highlights", "In-Venue", "OOH"];

function checkTypeVisible(channelNames){
    if(!_.isUndefined(channelNames))
    {
        if(!_.isArray(channelNames))
    channelNames = channelNames.split("<<!!>>");
    return channelNames.reduce((prev, curr) => {
        if(NO_TYPE_CHANNELS.includes(curr))
        return prev || false
        return prev || true
    }, false);
}
return true;
}

var shouldTypeVisible = checkTypeVisible

export  {shouldTypeVisible};